import { PercentageBreakdownProvider } from './context';
import type {
  PercentageBreakdownItem,
  PercentageBreakdownSize,
  PercentageBreakdownVariant,
} from './types';

export type PercentageBreakdownProps = React.PropsWithChildren<{
  data: PercentageBreakdownItem[];
  size?: PercentageBreakdownSize;
  /**
   * The variant of the PercentageBreakdown.
   * The default variant is default.
   */
  variant?: PercentageBreakdownVariant;
}>;

/**
 * PercentageBreakdown is a container component that provides context for child components.
 */
export const PercentageBreakdown = ({
  data,
  size,
  variant,
  children,
}: PercentageBreakdownProps) => {
  return (
    <PercentageBreakdownProvider
      value={{
        data,
        size,
        variant,
      }}
    >
      {children}
    </PercentageBreakdownProvider>
  );
};
PercentageBreakdown.displayName = 'PercentageBreakdown';
